import React from "react";
import { BsBookmarkPlus } from "react-icons/bs";
// import { Link } from "react-router-dom";
import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import useAuthContext from "../AuthContext/AuthContext";
import FlexMovies from "../FlexMovies";
import { Movies } from "../screen components/Data/MovieData";

const Banner = ({ movie }) => {
  const { handleFilter } = useAuthContext();

  const handleCart = (id) => {
    handleFilter(id);
  };
  return (
    //importing swiper packages from the swiper npm packages
    <div className="relative w-full h-full">
      <Swiper
        direction="horizontal"
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        speed={1000}
        modules={[Autoplay]}
        autoplay={{ delay: 6000, disableOnInteraction: false }}
        className="w-full xl:h-full bg-dry lg:h-screen h-full"
      >
        {/* //looping through the movies custom files  */}

        {Movies.slice(0, 6).map((movie, index) => (
          <SwiperSlide key={index} className="relative rounded overflow-hidden">
            <img
              src={movie.image}
              alt={movie.name}
              className="w-full object-cover lg:h-screen h-screen "
            />
            <div className="absolute linear-bg xl:pl-52 sm:pl-32 pl-8 top-0 bottom-0 right-0 left-0 flex flex-col justify-center lg:gap-8 md:gap-5 gap-4">
              <h1 className="xl:text-6xl truncate capitalize font-sans sm:text-2xl text-xl font-bold">
                {movie.name}
              </h1>
              <div className="flex gap-5 items-center text-text">
                <FlexMovies movie={movie} />
              </div>
              <div className="w-96 text-justify text-2xl text-text">
                {movie.desc}
              </div>
              <div className="flex gap-5 items-center">
                <a
                  href={movie?.video}
                  target="_blank"
                  rel="noreferrer"
                  className="bg-subMain hover:text-main transitions text-white px-8 py-3 rounded font-medium sm:text-sm text-xs"
                >
                  Watch
                </a>
                <button
                  onClick={() => handleCart(movie.id)}
                  className="bg-white hover:text-subMain transitions text-white px-4 py-3 rounded text-2xl bg-opacity-30"
                >
                  <BsBookmarkPlus />
                </button>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Banner;
